export default {
  transitionDuration: 1000,
  margins: {
    top: 30,
    right: 20,
    bottom: 30,
    left: 30
  }
}
